import React, { useState } from "react";
import { X } from "lucide-react";
import { GALLERY } from "../mock";

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="py-24 bg-[#F3ECE0]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-[#BF9A5A] text-sm font-700">معرض المشروع</span>
          <h2 className="font-display text-3xl lg:text-5xl font-700 text-[#241C15] mt-3">
            الواجهات والتصميم المعماري
          </h2>
          <p className="text-stone-600 mt-5">صور تعرض التصميم الاستثنائي والتشطيبات الفاخرة.</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[220px]">
          {GALLERY.map((g, i) => (
            <button
              key={i}
              onClick={() => setActive(g)}
              className={`group relative rounded-2xl overflow-hidden shadow-md ${
                i === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <img
                src={g.src}
                alt={g.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#140f0a]/80 via-transparent to-transparent" />
              <span className="absolute bottom-3 right-4 text-white font-700 text-sm drop-shadow">
                {g.title}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-[70] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button className="absolute top-5 left-5 text-white" onClick={() => setActive(null)}>
            <X size={32} />
          </button>
          <img src={active.src} alt={active.title} className="max-h-[85vh] max-w-full rounded-xl" />
        </div>
      )}
    </section>
  );
};

export default Gallery;
